import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthRouteWrapper = () => {
  const isAuthenticated = Boolean(localStorage.getItem("userData"));
  const userData = isAuthenticated
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const location = useLocation();

  // If _not_ authenticated, render the nested public routes
  if (!isAuthenticated) {
    return <Outlet />;
  }

  // Build the two possible “last active” paths
  const lastId = userData?.lastActiveChat?.id;
  const msgPath = `/elsnertech/message/${lastId}`;
  const chPath = `/elsnertech/channels/${lastId}`;

  // If already on one of those, let child routes render
  if (location.pathname === msgPath || location.pathname === chPath) {
    return <Outlet />;
  }

  // Otherwise, redirect an authenticated user to their last active chat
  if (
    userData?.lastActiveChat?.type === "channel" ||
    userData?.lastActiveChat?.type === "channels"
  ) {
    return <Navigate to={chPath} replace />;
  } else {
    return <Navigate to={msgPath} replace />;
  }
};

export default AuthRouteWrapper;
